// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__CJwg0","container":"styles_container__KdDpd","h1":"styles_h1__tKkAU","title":"styles_title__PGL6x"};